import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from './_nav.css'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import AuthModal from 'components/auth/AuthModal'
import fitness from 'images/sites/fitness/logo.svg'
import walk from 'images/sites/walk/logo.svg'
import run from 'images/sites/run/logo.svg'
import ride from 'images/sites/ride/logo.svg'
import hike from 'images/sites/hike/logo.svg'
import uarun from 'images/sites/uarun/logo.svg'
import uacfLogo from 'images/uacf-logo.png'
import classnames from 'classnames'
import * as actions from 'services/landing/actions'
import isServer from 'shared/isServer'
import { push } from 'connected-react-router'
import Button from '@uacf/web-library/button'

const logos = { fitness, walk, run, ride, hike, uarun }

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  signUp: actions.signUp,
  logIn: actions.logIn,
  push,
}

export class Nav extends Component {

  static propTypes = {
    showShortcuts: PropTypes.bool,
    showPremium: PropTypes.bool,
    showAuth: PropTypes.bool,
    showMobileNav: PropTypes.bool,
    showMainNav: PropTypes.bool,
    showPrivacyHelp: PropTypes.bool,
    loggedIn: PropTypes.bool,
    hasEvent: PropTypes.bool,
    navContainer: PropTypes.bool,
    site: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      shortName: PropTypes.string,
    }),
    username: PropTypes.string,
    storeLink: PropTypes.string,
    userId: PropTypes.number,
    isPremium: PropTypes.bool,
    uacf: PropTypes.bool,
    logIn: PropTypes.func,
    signUp: PropTypes.func,
    push: PropTypes.func,
  };

  static defaultProps = {
    showShortcuts: true,
    showPremium: true,
    showAuth: true,
    navContainer: true,
    middleContainer: true,
    showMobileNav: true,
    showPrivacyHelp: false,
    site: 'fitness',
    loggedIn: false,
    hasEvent: false,
    isPremium: false,
    uacf: false,
  };

  state = {
    subnav: null,
  };

  handleHideSubnav = () => {
    this.setState({ subnav: null })
  };

  handleShowSubnav = (subnav) => () => {
    this.setState({ subnav })
  };

  handleHideAuthModal = () => {
    this.setState({ showAuthModal: false })
  };

  render () {
    const {
      site,
      showShortcuts,
      showPremium,
      showAuth,
      showMobileNav,
      showPrivacyHelp,
      showMainNav,
      loggedIn,
      hasEvent,
      username,
      storeLink,
      isPremium,
      userId,
      navContainer,
      uacf,
      logIn,
      signUp,
    } = this.props

    const className = classnames(styles.container, {
      [styles.noShadow]: showShortcuts,
      [styles.navContainer]: navContainer,
      [styles.hideMobileNav]: !showMobileNav,
    })

    const { showAuthModal, authMode } = this.state
    const nextPage = encodeURIComponent(isServer() ? '' : window.location.pathname)

    return (
      <header role='banner' className={className}>

        <AuthModal
          scrollable={true}
          isOpen={showAuthModal}
          defaultMode={authMode}
          onRequestedClose={this.handleHideAuthModal}
          onLoginSuccess={this.handleHideAuthModal}
          onSignupSuccess={this.handleHideAuthModal}
        />

        <div className={styles.inner}>

          <nav className={styles.main}>

            <a className={styles.logo} href={loggedIn ? '/my_home/' : '/'}>
              <h1>
                <img
                  alt={site.name}
                  className={styles.logoImage}
                  src={uacf ? uacfLogo : logos[site.slug]}
                />
              </h1>
            </a>

            { showMainNav ?
              <ul className={styles.mainList}>

                <li
                  className={styles.mainItem}
                  onMouseEnter={this.handleShowSubnav('training')}
                  onMouseLeave={this.handleHideSubnav}
                >

                  <a href='/workouts' className={styles.mainLink}>
                    <FormattedMessage id='site.nav.training' defaultMessage='Training' />
                  </a>

                  {this.state.subnav === 'training' ?
                    <ul className={styles.mainSub}>
                      {loggedIn ?
                        <li className={styles.mainSubItem}>
                          <a className={styles.mainSubLink} href='/workouts/'>
                            <FormattedMessage id='site.nav.workouts' defaultMessage='Workouts' />
                          </a>
                        </li>
                      : null}

                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/training-plans/'>
                          <FormattedMessage id='site.nav.training_plans' defaultMessage='Training Plans' />
                        </a>
                      </li>

                      {loggedIn ?
                        <li className={styles.mainSubItem}>
                          <Link className={styles.mainSubLink} to={`/profile/${userId}/goals`}>
                            <FormattedMessage id='site.nav.goals' defaultMessage='Goals' />
                          </Link>
                        </li>
                      : null}

                      {loggedIn ?
                        <li className={styles.mainSubItem}>
                          <a className={styles.mainSubLink} href={`/profile/${userId}/achievements`}>
                            <FormattedMessage id='site.nav.achievements' defaultMessage='Achievements' />
                          </a>
                        </li>
                      : null}

                      {loggedIn ?
                        <li className={styles.mainSubItem}>
                          <a className={styles.mainSubLink} href='/gear/gear-locker/'>
                            <FormattedMessage id='site.nav.gear_tracker' defaultMessage='Gear Tracker' />
                          </a>
                        </li>
                      : null}

                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/nutrition/'>
                          <FormattedMessage id='site.nav.nutrition' defaultMessage='Nutrition' />
                        </a>
                      </li>

                      {loggedIn && hasEvent ?
                        <li className={styles.mainSubItem}>
                          <a className={styles.mainSubLink} href='/events'>
                            <FormattedMessage id='site.nav.events' defaultMessage='Events' />
                          </a>
                        </li>
                      : null}

                    </ul>
                  : null}

                </li>

                <li
                  className={styles.mainItem}
                  onMouseEnter={this.handleShowSubnav('routes')}
                  onMouseLeave={this.handleHideSubnav}
                >
                  <Link className={styles.mainLink} to='/routes'>
                    <FormattedMessage id='site.nav.routes' defaultMessage='Routes' />
                  </Link>

                  {this.state.subnav === 'routes' && loggedIn ?
                    <ul className={styles.mainSub}>
                      <li className={styles.mainSubItem}>
                        <Link className={styles.mainSubLink} to='/routes/search'>
                          <FormattedMessage id='site.nav.find_routes' defaultMessage='Find Routes' />
                        </Link>
                      </li>
                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/routes/create'>
                          <FormattedMessage id='site.nav.route_create' defaultMessage='Create Route' />
                        </a>
                      </li>
                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/maps/auto_route'>
                          <FormattedMessage id='site.nav.route_genius' defaultMessage='Route Genius' />
                        </a>
                      </li>
                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/maps/courses'>
                          <FormattedMessage id='site.nav.courses' defaultMessage='Courses' />
                        </a>
                      </li>
                      <li className={styles.mainSubItem}>
                        <Link className={styles.mainSubLink} to='/routes/my_routes'>
                          <FormattedMessage id='site.nav.my_routes' defaultMessage='My Routes &amp; Courses' />
                        </Link>
                      </li>
                      <li className={styles.mainSubItem}>
                        <a className={styles.mainSubLink} href='/us'>
                          <FormattedMessage id='site.nav.find_your_city' defaultMessage='Find Your City' />
                        </a>
                      </li>
                    </ul>
                  : null}

                </li>

                <li className={styles.mainItem}>
                  <a className={styles.mainLink} href='/challenges'>
                    <FormattedMessage id='site.nav.challenges' defaultMessage='Challenges' />
                  </a>
                </li>

                {!isPremium && showPremium ?
                  <li className={styles.mainItem}>
                    <a className={styles.mainLink} href={`http://mvp.${site.shortName}.com/`}>
                      <span className={styles.premiumLinkLong}>
                        <FormattedMessage id='site.nav.premium' defaultMessage='Go MVP' />
                      </span>
                      <span className={styles.premiumLinkShort}>
                        <FormattedMessage id='site.nav.premiumShort' defaultMessage='MVP' />
                      </span>
                    </a>
                  </li>
                : null}

                <li className={styles.mainItem}>
                  <a className={styles.mainLink} href='/blog'>
                    <FormattedMessage id='site.nav.blog' defaultMessage='Blog' />
                  </a>
                </li>

                <li className={styles.mainItem}>
                  <a href={`${storeLink}|Nav`} className={styles.shopButton}>
                    <Svg name='ua' className={styles.shopLogo} />
                    <FormattedMessage id='site.nav.shop' defaultMessage='Shop' />
                  </a>
                </li>
              </ul>
            : null}
            { showPrivacyHelp && loggedIn ?
              <ul className={styles.privacyList}>
                <li className={styles.mainItem}>
                  <a href='/privacy_center/help' className={styles.mainLink}>
                    <FormattedMessage id='site.nav.privacy.help' defaultMessage='Help' />
                  </a>
                </li>
              </ul>
            : null}
          </nav>

          <nav className={styles.utility}>
            {loggedIn && showAuth ?
              <ul className={styles.utilityList}>
                <li
                  className={styles.utilityItem}
                  onMouseEnter={this.handleShowSubnav('profile')}
                  onMouseLeave={this.handleHideSubnav}
                >

                  <img
                    src={`/profile/${username}/picture?size=Small`}
                    className={styles.avatarImage}
                    height='34'
                    width='34'
                  />

                  {this.state.subnav === 'profile' ?
                    <ul className={styles.utilSub}>
                      <li className={styles.utilSubItem}>
                        <Link className={styles.utilSubLink} to='/people/friends'>
                          <FormattedMessage id='site.nav.friends' defaultMessage='Friends' />
                        </Link>
                      </li>
                      <li className={styles.utilSubItem}>
                        <a className={styles.utilSubLink} href='/workout/import/dashboard'>
                          <FormattedMessage id='site.nav.devices' defaultMessage='Devices' />
                        </a>
                      </li>
                      <li className={styles.utilSubItem}>
                        <a className={styles.utilSubLink} href='http://support.mapmyfitness.com/login'>
                          <FormattedMessage id='site.nav.support' defaultMessage='Support' />
                        </a>
                      </li>
                      <li className={styles.utilSubItem}>
                        <a className={styles.utilSubLink} href='/account/settings'>
                          <FormattedMessage id='site.nav.settings' defaultMessage='Settings' />
                        </a>
                      </li>
                      <li className={styles.utilSubItem}>
                        <a className={styles.utilSubLink} href='/auth/logout'>
                          <FormattedMessage id='site.nav.logout' defaultMessage='Logout' />
                        </a>
                      </li>
                    </ul>
                  : null}

                </li>

              </ul>
            : null}
            {!loggedIn && showAuth ?
              <ul className={styles.utilityList}>
                <li className={styles.utilityItem}>
                  <Button
                    onClick={() => {
                      this.props.push(`/auth/login/${nextPage ? `?next=${nextPage}` : ''}`)
                      logIn('log_in_header')
                    }}>
                    <FormattedMessage id='site.nav.login' defaultMessage='Log in' />
                  </Button>
                </li>
                <li className={styles.utilityItem}>
                  <Button variant="contained" color='primary' onClick={() => {
                    this.props.push(`/auth/signup/${nextPage ? `?next=${nextPage}` : ''}`)
                    signUp('sign_up_header')
                  }}>
                    <FormattedMessage id='site.nav.signup' defaultMessage='Sign Up' />
                  </Button>
                </li>
              </ul>
            : null}
          </nav>

        </div>

      </header>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(Nav)
